import React from "react";
import BreadCrumb from "common/breadcrumb";
import Basic from "./basic";
import RowBorders from "./row-borders";
import HoverAble from "./hoverable";
import BorderedTable from "./bordered-table";
import HiddenColumns from "./hidden-columns";
import AddRows from "./add-rows";

export interface column { header: string; accessorKey: string; enableColumnFilter: boolean; enableSorting: boolean };

const ReactDataTable = () => {

    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Datatable" pageTitle="Tables" />

                <Basic />
                <RowBorders />
                <HoverAble />
                <BorderedTable />
                <HiddenColumns />
                <AddRows />
            </div>
        </React.Fragment>
    );
}

export default ReactDataTable;